var _defs, _path, _path2, _path3, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { SvgIcon as Svg } from 'ha/ui/SvgIcon';

const SvgCollectRentOnline = props => /*#__PURE__*/React.createElement(Svg, _extends({
  id: "collect-rent-online_svg__Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".collect-rent-online_svg__cls-1{fill:none;stroke:#2d4658;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.3px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "collect-rent-online_svg__Shape_1188",
  "data-name": "Shape 1188",
  className: "collect-rent-online_svg__cls-1",
  d: "M10.74 22.6l-7.61-2.9a1.41 1.41 0 00-1.6.5A1.44 1.44 0 002 22.33c1.81 1 8.11 4 9.22 4.56 4 1.94 4.19 1.81 12.82-1.06l3.29 1.36"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "collect-rent-online_svg__cls-1",
  d: "M27.37 20L24 18.71c-4.11-3.48-7.87.71-7.87.71H11.7A1.69 1.69 0 0010 21.1a1.69 1.69 0 001.69 1.68h6.7m9.32-5.58h3.06v11.65h-3.06z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.31 10.14a2.34 2.34 0 011.15 2v3.22h10.3a2.1 2.1 0 002.1-2.1V8H10.7a4.38 4.38 0 01.61 2.14zm8 1.86h2.9a.65.65 0 010 1.3h-2.9a.65.65 0 010-1.3zm3.45-9.5H8.28a2.1 2.1 0 00-2.09 2.1v1.3A3.94 3.94 0 017 5.82a4.17 4.17 0 011.33.23h16.53V4.6a2.1 2.1 0 00-2.1-2.1z",
  fill: "#00c5ba"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "collect-rent-online_svg__Interface-Essential_Lock_Unlock_lock-1",
  "data-name": "Interface-Essential / Lock/Unlock / lock-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "collect-rent-online_svg__Group_125",
  "data-name": "Group 125"
}, /*#__PURE__*/React.createElement("g", {
  id: "collect-rent-online_svg__lock-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.88 13.61a.92.92 0 00-1.83 0 .88.88 0 00.41.74v.91a.5.5 0 00.5.5.5.5 0 00.5-.5v-.91a.87.87 0 00.42-.74z",
  fill: "#2d4658"
}), /*#__PURE__*/React.createElement("path", {
  id: "collect-rent-online_svg__Rectangle-path_43",
  "data-name": "Rectangle-path 43",
  className: "collect-rent-online_svg__cls-1",
  d: "M3.45 11.75a.41.41 0 01.41-.41h6.21a.41.41 0 01.41.41v5a.41.41 0 01-.41.41H3.86a.41.41 0 01-.41-.41z"
}), /*#__PURE__*/React.createElement("path", {
  id: "collect-rent-online_svg__Shape_765",
  "data-name": "Shape 765",
  className: "collect-rent-online_svg__cls-1",
  d: "M4.69 9.89a2.28 2.28 0 014.55 0v1.45H4.69z"
}))))));

export default SvgCollectRentOnline;